// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForecastSchema } from './v1/forecastSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const showTaskPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Task ID"),
});

export const showTaskHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Task details
 */
export const showTask200Schema = z.lazy(() => v1ForecastSchema);

/**
 * @description Unauthorized
 */
export const showTask401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Task not found
 */
export const showTask404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const showTaskQueryResponseSchema = z.lazy(() => showTask200Schema);
